(function () {
  function cartRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function updateCartCount(count) {
    document.querySelectorAll('.alleras-cart-count').forEach(function (el) {
      el.dataset.count = String(count);
      el.textContent = count > 0 ? String(count) : '';
    });
  }

  function getPage() {
    return document.querySelector('[data-alleras-cart]');
  }

  function refreshSection() {
    var page = getPage();
    if (!page) return Promise.resolve();

    var sectionId = page.dataset.sectionId;
    if (!sectionId) return Promise.resolve();

    var url =
      cartRoot() +
      '?sections=' +
      encodeURIComponent(sectionId) +
      '&sections_url=' +
      encodeURIComponent(window.location.pathname);

    return fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-alleras-cart]');
        if (!next) return;

        page.replaceWith(next);
        bindPage();
      });
  }

  function changeLine(line, quantity) {
    var page = getPage();
    if (!page) return Promise.resolve();

    var sectionId = page.dataset.sectionId;
    page.classList.add('is-updating');

    return fetch(cartRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: sectionId,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.errors) throw new Error(data.errors);

        updateCartCount(data.item_count);
        document.dispatchEvent(new CustomEvent('alleras:cart:update', { detail: { cart: data } }));

        if (data.sections && data.sections[sectionId]) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data.sections[sectionId], 'text/html');
          var next = doc.querySelector('[data-alleras-cart]');
          if (next) {
            page.replaceWith(next);
            bindPage();
            return;
          }
        }

        return refreshSection();
      })
      .finally(function () {
        var current = getPage();
        if (current) current.classList.remove('is-updating');
      });
  }

  function applyDiscount(code) {
    var page = getPage();
    if (!page || !code) return Promise.resolve();

    var sectionId = page.dataset.sectionId;
    page.classList.add('is-updating');

    return fetch(cartRoot() + 'cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var existing = (cart.cart_level_discount_applications || [])
          .map(function (discount) {
            return discount.title;
          })
          .filter(Boolean);

        if (existing.indexOf(code) !== -1) return existing.join(',');

        return existing.concat(code).join(',');
      })
      .then(function (discountValue) {
        return fetch(cartRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            discount: discountValue,
            sections: sectionId,
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var invalid =
          data.discount_codes &&
          data.discount_codes.some(function (entry) {
            return entry.code === code && entry.applicable === false;
          });

        if (invalid) throw new Error('invalid');

        updateCartCount(data.item_count);
        document.dispatchEvent(new CustomEvent('alleras:cart:update', { detail: { cart: data } }));

        if (data.sections && data.sections[sectionId]) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data.sections[sectionId], 'text/html');
          var next = doc.querySelector('[data-alleras-cart]');
          if (next) {
            page.replaceWith(next);
            bindPage();
          }
        } else {
          return refreshSection();
        }
      })
      .finally(function () {
        var current = getPage();
        if (current) current.classList.remove('is-updating');
      });
  }

  function bindPage() {
    var page = getPage();
    if (!page) return;

    page.querySelectorAll('[data-alleras-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = Number(btn.getAttribute('data-alleras-cart-remove'));
        if (!line) return;
        changeLine(line, 0).catch(function () {});
      });
    });

    page.querySelectorAll('[data-alleras-cart-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-alleras-cart-line]');
        if (!item) return;

        var line = Number(item.getAttribute('data-alleras-cart-line'));
        var valueEl = item.querySelector('[data-alleras-cart-qty-value]');
        var current = valueEl ? Number(valueEl.textContent) : 1;
        var delta = Number(btn.getAttribute('data-alleras-cart-qty-change'));
        var nextQty = Math.max(1, current + delta);

        if (nextQty === current) return;
        changeLine(line, nextQty).catch(function () {});
      });
    });

    var discountForm = page.querySelector('[data-alleras-cart-discount-form]');
    if (discountForm) {
      discountForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = discountForm.querySelector('input[name="discount"]');
        var error = page.querySelector('[data-alleras-cart-discount-error]');
        if (!(input instanceof HTMLInputElement) || !input.value.trim()) return;

        if (error) error.hidden = true;

        applyDiscount(input.value.trim())
          .then(function () {
            input.value = '';
          })
          .catch(function () {
            if (error) error.hidden = false;
          });
      });
    }
  }

  function boot() {
    bindPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
